export default __webpack_public_path__ + "static/media/admin-2.27fdc74b.png";